import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Switch from '@mui/material/Switch';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { FormControlLabel, FormLabel, MenuItem, Select } from '@mui/material';
import { useState } from 'react';
import { useEffect } from 'react';
import { postApi, getApi } from 'views/services/api';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router';
import PropTypes from 'prop-types';

const SingleInvoiceDialog = (props) => {
  const navigate = useNavigate();
  const { open, handleClose, data } = props;
  const [hotelData, setHotelData] = useState([]);
  const [haveFoodGst, setHaveFoodGst] = useState(true);
  const [haveRoomGst, setHaveRoomGst] = useState(true);
  const [roomGstAmount, setRoomGstAmount] = useState();
  const [foodGstAmount, setFoodGstAmount] = useState();
  const hotel = JSON.parse(localStorage.getItem('hotelData'));
  const [totalFoodAmount, setTotalFoodAmount] = useState(0);

  // function for fetching hotel data from the db

  const fetchHotelData = async () => {
    try {
      // const response = await getApi(`api/hotel/view/${hotel._id}`);
      const response = await getApi(`api/hotel/view/${hotel?.hotelId}`);
      setHotelData(response?.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchHotelData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // function for calculating total food amount
  const calculateFoodAmount = () => {
    if (!data || !data.foodItems) {
      return 0;
    }

    const totalFoodAmount = data.foodItems.reduce((total, foodData) => {
      return total + foodData.quantity * foodData.price;
    }, 0);

    return totalFoodAmount;
  };
  useEffect(() => {
    setTotalFoodAmount(calculateFoodAmount());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);
  const initialValues = {
    name: `${data?.customerDetails?.firstName} ${data?.customerDetails?.lastName}`,
    address: data?.customerDetails?.address,
    roomRent: data?.totalPayment,
    advanceAmount: data?.advanceAmount,
    pendingAmount: data?.totalAmount,
    roomDiscount: '',
    paymentMethod: 'cash',
    haveRoomGst: true,
    roomgstpercentage: hotelData?.roomgstpercentage,
    foodgstpercentage: hotelData?.foodgstpercentage,
    haveFoodGst: true,
    gstNumber: data?.customerDetails?.idcardNumber || '',
    totalRoomAmount: '',
    foodAmount: totalFoodAmount,
    foodDiscount: '',
    totalFoodAmount: '',
    totalFoodAndRoomAmount: ''
  };

  const validationSchema = yup.object().shape({
    name: yup.string().required('Customer name is required'),
    address: yup.string().required('Address is required'),
    roomRent: yup.number().min(0, 'Room rent cannot be negative'),
    advanceAmount: yup.number().min(0, 'Advance amount cannot be negative'),
    pendingAmount: yup.number().min(0, 'Pending amount cannot be negative'),
    roomDiscount: yup.number().min(0, 'Discount cannot be negative'),
    paymentMethod: yup.string().required('Payment Method is required'),
    haveRoomGst: yup.boolean(),
    roomgstpercentage: yup.number().min(0, 'GST percentage cannot be negative'),
    foodgstpercentage: yup.number().min(0, 'GST percentage cannot be negative'),
    haveFoodGst: yup.boolean(),
    gstNumber: yup.string().when('haveRoomGst', {
      is: true,
      then: yup.string(),
      otherwise: yup.string()
    }),
    totalRoomAmount: yup.number().required('Total amount is required').min(0, 'Total amount cannot be negative'),
    foodAmount: yup.number().min(0, 'Food amount cannot be negative'),
    foodDiscount: yup.number().min(0, 'Discount cannot be negative'),
    totalFoodAmount: yup.number().required('Total amount is required').min(0, 'Total amount cannot be negative')
  });

  // function for generating Invoice Number
  const generateInvoiceNumber = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');

    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let randomPart = '';
    const charactersLength = characters.length;
    for (let i = 0; i < 4; i++) {
      randomPart += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    const invoiceNumber = `INV-${year}-${month}-${day}-${randomPart}`;
    return invoiceNumber;
  };

  // function for generating Invoice

  const generateInvoice = async (values, resetForm) => {
    try {
      // values.hotelId = hotel?._id;
      values.hotelId = hotel?.hotelId;
      values.reservationId = data?._id;
      values.invoiceNumber = generateInvoiceNumber();
      values.customerPhoneNumber = data?.customerDetails?.phoneNumber;
      values.finalCheckInTime = data?.FinalCheckInTime;
      values.foodGstAmount = foodGstAmount;
      values.roomGstAmount = roomGstAmount;
      values.totalFoodAndRoomAmount = values.totalFoodAmount + values.totalRoomAmount;
      const response = await postApi('api/singleinvoice/add', values);
      toast.success('Invoice generated successfully');
      handleClose();
      resetForm();
      setTimeout(() => {
        navigate(`/singlebill/view/${response.data.reservationId}`);
      }, 200);
    } catch (error) {
      console.log(error);
      toast.error('cannot generate Invoice');
    }
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    enableReinitialize: true,
    onSubmit: async (values, { resetForm }) => {
      generateInvoice(values, resetForm);
    }
  });

  const handleRoomGstToggle = () => {
    setHaveRoomGst(!haveRoomGst);
    formik.setFieldValue('haveRoomGst', !haveRoomGst);
  };

  const handleFoodGstToggle = () => {
    setHaveFoodGst(!haveFoodGst);
    formik.setFieldValue('haveFoodGst', !haveFoodGst);
  };

  const calculateTotalRoomAmount = () => {
    const totalAmount = formik.values.roomRent - formik.values.roomDiscount;
    let gstAmount = 0;

    if (haveRoomGst && formik.values.roomgstpercentage > 0) {
      const gstRate = formik.values.roomgstpercentage / 100;
      const baseAmount = totalAmount / (1 + gstRate);
      gstAmount = totalAmount - baseAmount;
    }

    setRoomGstAmount(gstAmount);
    formik.setFieldValue('totalRoomAmount', totalAmount);
  };

  const calculateTotalFoodAmount = () => {
    const totalAmount = formik.values.foodAmount - formik.values.foodDiscount;
    let gstAmount = 0;

    if (haveFoodGst && formik.values.foodgstpercentage > 0) {
      const gstRate = formik.values.foodgstpercentage / 100;
      const baseAmount = totalAmount / (1 + gstRate);
      gstAmount = totalAmount - baseAmount;
    }

    setFoodGstAmount(gstAmount);
    formik.setFieldValue('totalFoodAmount', totalAmount);
  };

  useEffect(() => {
    calculateTotalFoodAmount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values.foodAmount, formik.values.foodDiscount, formik.values.foodgstpercentage, haveFoodGst]);
  useEffect(() => {
    calculateTotalRoomAmount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    formik.values.pendingAmount,
    formik.values.roomDiscount,
    formik.values.roomgstpercentage,
    haveRoomGst,
    formik.values.pendingAmount,
    formik.values.advanceAmount
  ]);

  return (
    <div>
      <Dialog open={open} aria-labelledby="scroll-dialog-title" aria-describedby="scroll-dialog-description">
        <DialogTitle
          id="scroll-dialog-title"
          style={{
            display: 'flex',
            justifyContent: 'space-between'
          }}
        >
          <Typography variant="h6">Invoice Information</Typography>
          <Typography>
            <Button onClick={handleClose} style={{ color: 'red' }}>
              Cancel
            </Button>
          </Typography>
        </DialogTitle>

        <DialogContent dividers>
          <form onSubmit={formik.handleSubmit} encType="multipart/form-data">
            {/* Invoice Information */}
            <Grid container rowSpacing={3} columnSpacing={{ xs: 0, sm: 2 }}>
              <Grid item xs={12} sm={6}>
                <FormLabel>Customer Name (Bill to)</FormLabel>
                <TextField
                  id="name"
                  name="name"
                  size="small"
                  type="text"
                  fullWidth
                  placeholder="Enter customer name"
                  value={formik.values.name}
                  onChange={formik.handleChange}
                  error={formik.touched.name && Boolean(formik.errors.name)}
                  helperText={formik.touched.name && formik.errors.name}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormLabel>Address</FormLabel>
                <TextField
                  id="address"
                  name="address"
                  size="small"
                  type="text"
                  fullWidth
                  placeholder="Enter customer address"
                  value={formik.values.address}
                  onChange={formik.handleChange}
                  error={formik.touched.address && Boolean(formik.errors.address)}
                  helperText={formik.touched.address && formik.errors.address}
                />
              </Grid>
            </Grid>
            <Typography variant="h6" sx={{ margin: '14px 0px' }}>
              Room Bill Information
            </Typography>
            <Grid container rowSpacing={3} columnSpacing={{ xs: 0, sm: 2 }}>
              {/* Customer Name and Address */}

              {/* Room Rent */}
              <Grid item xs={12} sm={6}>
                <FormLabel>Room Rent</FormLabel>
                <TextField
                  id="roomRent"
                  name="roomRent"
                  size="small"
                  type="number"
                  fullWidth
                  value={formik.values.roomRent}
                  onChange={formik.handleChange}
                  error={formik.touched.roomRent && Boolean(formik.errors.roomRent)}
                  helperText={formik.touched.roomRent && formik.errors.roomRent}
                />
              </Grid>
              {/* Advance Amount  */}
              <Grid item xs={12} sm={6}>
                <FormLabel>Advance Amount</FormLabel>
                <TextField
                  id="advanceAmount"
                  name="advanceAmount"
                  size="small"
                  type="number"
                  fullWidth
                  value={formik.values.advanceAmount}
                  onChange={formik.handleChange}
                  error={formik.touched.advanceAmount && Boolean(formik.errors.advanceAmount)}
                  helperText={formik.touched.advanceAmount && formik.errors.advanceAmount}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormLabel>Pending Amount</FormLabel>
                <TextField
                  id="pendingAmount"
                  name="pendingAmount"
                  size="small"
                  type="number"
                  fullWidth
                  value={formik.values.pendingAmount}
                  onChange={formik.handleChange}
                  error={formik.touched.pendingAmount && Boolean(formik.errors.pendingAmount)}
                  helperText={formik.touched.pendingAmount && formik.errors.pendingAmount}
                />
              </Grid>
              {/* roomDiscount */}
              <Grid item xs={12} sm={6}>
                <FormLabel>Discount</FormLabel>
                <TextField
                  id="roomDiscount"
                  name="roomDiscount"
                  size="small"
                  type="number"
                  fullWidth
                  placeholder="In {currency}"
                  value={formik.values.roomDiscount}
                  onChange={(e) => {
                    let value = e.target.value.trim();
                    if (value === '') {
                      value = '';
                    } else {
                      value = value.replace(/\D/, '').slice(0, 6);
                      value = Math.max(0, Math.min(parseInt(value), formik.values.roomRent));
                      value = value === formik.values.roomRent ? formik.values.roomRent - 1 : value;
                    }
                    formik.setFieldValue('roomDiscount', value);
                  }}
                  error={formik.touched.roomDiscount && Boolean(formik.errors.roomDiscount)}
                  helperText={formik.touched.roomDiscount && formik.errors.roomDiscount}
                  disabled={formik.values.roomRent <= 0 || haveRoomGst}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormLabel>Payment Method</FormLabel>
                <Select
                  id="paymentMethod"
                  name="paymentMethod"
                  size="small"
                  fullWidth
                  placeholder="Select Payment Method"
                  value={formik.values.paymentMethod}
                  onChange={formik.handleChange}
                  error={formik.touched.paymentMethod && Boolean(formik.errors.paymentMethod)}
                >
                  <MenuItem value="default" disabled>
                    Select Payment Method
                  </MenuItem>
                  <MenuItem value="cash">Cash</MenuItem>
                  <MenuItem value="creditCard">Credit Card</MenuItem>
                  <MenuItem value="debitCard">Debit Card</MenuItem>
                  <MenuItem value="netBanking">Net Banking</MenuItem>
                  <MenuItem value="onlinePayment">Online Payment</MenuItem>
                </Select>
              </Grid>

              {/* GST Toggle */}
              <Grid item xs={12} sm={6}>
                <FormControlLabel control={<Switch checked={haveRoomGst} onChange={handleRoomGstToggle} />} label="Have Room GST" />
              </Grid>
              {/* GST Percentage */}
              {haveRoomGst && (
                <>
                  <Grid item xs={12} sm={6}>
                    <FormLabel>Identidad Fiscal (Opcional) / RIF</FormLabel>
                    <TextField
                      id="gstNumber"
                      name="gstNumber"
                      size="small"
                      type="text"
                      fullWidth
                      placeholder="Ej. J-12345678-9"
                      value={formik.values.gstNumber}
                      onChange={(e) => {
                        formik.handleChange(e);
                        calculateTotalRoomAmount();
                      }}
                      error={formik.touched.gstNumber && Boolean(formik.errors.gstNumber)}
                      helperText={formik.touched.gstNumber && formik.errors.gstNumber}
                    />
                  </Grid>

                  {!hotelData.roomgstpercentage ? (
                    <Grid item xs={12} sm={6}>
                      <FormLabel>GST Percentage</FormLabel>
                      <TextField
                        id="roomgstpercentage"
                        name="roomgstpercentage"
                        size="small"
                        type="number"
                        fullWidth
                        placeholder="In %"
                        value={formik.values.roomgstpercentage}
                        onChange={(e) => {
                          formik.handleChange(e);
                          calculateTotalRoomAmount();
                        }}
                        error={formik.touched.roomgstpercentage && Boolean(formik.errors.roomgstpercentage)}
                        helperText={formik.touched.roomgstpercentage && formik.errors.roomgstpercentage}
                      />
                    </Grid>
                  ) : (
                    ''
                  )}
                </>
              )}
              {/* Total Amount */}
              <Grid item xs={12} sm={6}>
                <FormLabel>Total Room Amount</FormLabel>
                <TextField
                  id="totalRoomAmount"
                  name="totalRoomAmount"
                  size="small"
                  type="number"
                  fullWidth
                  value={formik.values.totalRoomAmount}
                  onChange={formik.handleChange}
                  error={formik.touched.totalRoomAmount && Boolean(formik.errors.totalRoomAmount)}
                  helperText={formik.touched.totalRoomAmount && formik.errors.totalRoomAmount}
                />
              </Grid>
            </Grid>

            <Typography variant="h6" sx={{ margin: '14px 0px' }}>
              Food Bill Information
            </Typography>

            {/* //------------------------------------------------------food bill invoice  */}
            <Grid container rowSpacing={3} columnSpacing={{ xs: 0, sm: 2 }}>
              {/* Customer Name and Address */}
              <Grid item xs={12} sm={6}>
                <FormLabel>Food Amount</FormLabel>
                <TextField
                  id="foodAmount"
                  name="foodAmount"
                  size="small"
                  type="number"
                  fullWidth
                  value={formik.values.foodAmount}
                  onChange={formik.handleChange}
                  error={formik.touched.foodAmount && Boolean(formik.errors.foodAmount)}
                  helperText={formik.touched.foodAmount && formik.errors.foodAmount}
                />
              </Grid>
              {/* foodDiscount */}
              <Grid item xs={12} sm={6}>
                <FormLabel>Discount</FormLabel>
                <TextField
                  id="foodDiscount"
                  name="foodDiscount"
                  size="small"
                  type="number"
                  fullWidth
                  placeholder="In {currency}"
                  value={formik.values.foodDiscount}
                  onChange={(e) => {
                    let value = e.target.value.trim();
                    if (value === '') {
                      value = '';
                    } else {
                      value = value.replace(/\D/, '').slice(0, 6);
                      value = Math.max(0, Math.min(parseInt(value), formik.values.foodAmount));
                      value = value === formik.values.foodAmount ? formik.values.foodAmount - 1 : value;
                    }
                    formik.setFieldValue('foodDiscount', value);
                  }}
                  error={formik.touched.foodDiscount && Boolean(formik.errors.foodDiscount)}
                  helperText={formik.touched.foodDiscount && formik.errors.foodDiscount}
                  disabled={formik.values.foodAmount <= 0 || haveFoodGst}
                />
              </Grid>
              {/* GST Toggle */}
              <Grid item xs={12} sm={6}>
                <FormControlLabel control={<Switch checked={haveFoodGst} onChange={handleFoodGstToggle} />} label="Have Food GST" />
              </Grid>
              {/* GST Percentage */}
              {haveFoodGst && (
                <>
                  {!hotelData.foodgstpercentage ? (
                    <Grid item xs={12} sm={6}>
                      <FormLabel>GST Percentage</FormLabel>
                      <TextField
                        id="foodgstpercentage"
                        name="foodgstpercentage"
                        size="small"
                        type="number"
                        fullWidth
                        placeholder="In %"
                        value={formik.values.foodgstpercentage}
                        onChange={(e) => {
                          formik.handleChange(e);
                          calculateTotalFoodAmount();
                        }}
                        error={formik.touched.foodgstpercentage && Boolean(formik.errors.foodgstpercentage)}
                        helperText={formik.touched.foodgstpercentage && formik.errors.foodgstpercentage}
                      />
                    </Grid>
                  ) : (
                    ''
                  )}
                </>
              )}
              {/* Total Amount */}
              <Grid item xs={12} sm={6}>
                <FormLabel>Total Food Amount</FormLabel>
                <TextField
                  id="totalFoodAmount"
                  name="totalFoodAmount"
                  size="small"
                  type="number"
                  fullWidth
                  value={formik.values.totalFoodAmount}
                  onChange={formik.handleChange}
                  error={formik.touched.totalFoodAmount && Boolean(formik.errors.totalFoodAmount)}
                  helperText={formik.touched.totalFoodAmount && formik.errors.totalFoodAmount}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <FormLabel>Total Amount ( Room + Food )</FormLabel>
                <TextField
                  id="totalFoodAndRoomAmount"
                  name="totalFoodAndRoomAmount"
                  size="small"
                  type="number"
                  fullWidth
                  value={formik.values.totalRoomAmount + formik.values.totalFoodAmount}
                  error={formik.touched.totalFoodAndRoomAmount && Boolean(formik.errors.totalFoodAndRoomAmount)}
                  helperText={formik.touched.totalFoodAndRoomAmount && formik.errors.totalFoodAndRoomAmount}
                />
              </Grid>
            </Grid>
            {/* Submit Button */}
            <DialogActions>
              <Button type="submit" variant="contained" color="primary">
                Generate Invoice
              </Button>
            </DialogActions>
          </form>
        </DialogContent>
      </Dialog>
    </div>
  );
};
SingleInvoiceDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired
};

export default SingleInvoiceDialog;
